import React from "react";
// import { Link } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

import FCHeader from "../../components/Header/FCHeader.jsx";
import headerStyle from "../../assets/jss/material-kit-pro-react/components/headerStyle.jsx";

const style = () => ({
    ...headerStyle,
    mainHeader: {
        top:'27px',
        'background-color': 'transparent',
        'box-shadow': '0px 0px 0px'
    },
    toolbar: {
        'padding-left': 0,
        'padding-right': 0
    },
    media: {
        "@media screen and (max-width: 600px)":
            {
                display: 'none',
            }
    }
})

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileOpen: false,
            lastScrollTop: 0
        };
        this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
        this.headerColorChange = this.headerColorChange.bind(this);
        this.headerChangeSize = this.headerChangeSize.bind(this);
    }
    handleDrawerToggle() {
        this.setState({ mobileOpen: !this.state.mobileOpen });
    }
    componentDidMount() {
        if (this.props.changeColorOnScroll) {
            window.addEventListener("scroll", this.headerColorChange);
            window.addEventListener("scroll", this.headerChangeSize);
        }
    }

    headerChangeSize() {
        const { changeColorOnScroll } = this.props;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const windowsScrollTop = window.pageYOffset;
        const hasHeader = document.body.getElementsByTagName("header") !== null,
            hasDesktopSideBar = document.getElementById("facets-sidebar") !== null && document.getElementById("mobile-filter-bar") === null,
            hasMobileSideBar = document.getElementById("mobile-filter-bar") !== null;

        if (hasHeader) {

            if (scrollTop > this.state.lastScrollTop && windowsScrollTop > changeColorOnScroll.height) {
                // downscroll code
                document.body.getElementsByTagName("header")[1].style = "visibility: hidden; transition: visibility 0.5s, opacity 0.5s linear;"

                if (hasDesktopSideBar)
                    document.getElementById("facets-sidebar").style = "transition: height 0.5s; height: calc(100vh - 27px);";
                if (hasMobileSideBar)
                    document.getElementById("mobile-filter-bar").style = "transition: top 0.5s; top: 27px;";
            } 
            else {
                // upscroll code
                document.body.getElementsByTagName("header")[1].style = "visibility: visible; transition: visibility 0.5s, opacity 0.5s linear;"

                if (hasDesktopSideBar)
                    document.getElementById("facets-sidebar").style.height = "";
                if (hasMobileSideBar)
                    document.getElementById("mobile-filter-bar").style.top = "auto";
            }
            this.setState({ lastScrollTop: scrollTop <= 0 ? 0 : scrollTop });
        }
    }

    headerColorChange() {
        const { classes, color, changeColorOnScroll } = this.props;
        const windowsScrollTop = window.pageYOffset;
        if (windowsScrollTop > changeColorOnScroll.height) {
            document.body.getElementsByTagName("header")[1].classList.remove(classes[color]);
            document.body.getElementsByTagName("header")[1].classList.add(classes[changeColorOnScroll.color]);
        } else {
            document.body.getElementsByTagName("header")[1].classList.add(classes[color]);
            document.body.getElementsByTagName("header")[1].classList.remove(classes[changeColorOnScroll.color]);
        }
    }
    componentWillUnmount() {
        if (this.props.changeColorOnScroll) {
            window.removeEventListener("scroll", this.headerColorChange);
            window.removeEventListener("scroll", this.headerChangeSize);
        }
    }
    render() {
        const { classes, color, /*links, brand, */fixed, absolute, brandComponent } = this.props;
        const appBarClasses = classNames({

            [classes.media]: true,
            [classes.appBar]: true,
            [classes[color]]: color,
            [classes.absolute]: absolute,
            [classes.fixed]: fixed,
            [classes.mainHeader]: true
        });
        return (
            <div>
                <FCHeader/>
                <AppBar title="News" className={appBarClasses}>
                    <Toolbar className={classes.container + ' ' + classes.toolbar}>
                        {brandComponent}
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

Header.defaultProp = {
    color: "white"
};

Header.propTypes = {
    classes: PropTypes.object.isRequired,
    color: PropTypes.oneOf([
        "primary",
        "info",
        "success",
        "warning",
        "danger",
        "transparent",
        "white",
        "rose",
        "dark"
    ]),
    links: PropTypes.node,
    brand: PropTypes.string,
    fixed: PropTypes.bool,
    absolute: PropTypes.bool,
    // this will cause the sidebar to change the color from
    // this.props.color (see above) to changeColorOnScroll.color
    // when the window.pageYOffset is heigher or equal to
    // changeColorOnScroll.height and then when it is smaller than
    // changeColorOnScroll.height change it back to
    // this.props.color (see above)
    changeColorOnScroll: PropTypes.shape({
        height: PropTypes.number.isRequired,
        color: PropTypes.oneOf([
            "primary",
            "info",
            "success",
            "warning",
            "danger",
            "transparent",
            "white",
            "rose",
            "dark"
        ]).isRequired
    }),
    brandComponent: PropTypes.element
};

export default withStyles(style)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx